import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/regime/';

class RegimeService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.token = data;
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            }
        });
    }


    findAllRegimes(idCliente) {
        return axios.get(API_URL + 'findAllRegimes?idCliente=' + idCliente, { headers: this.headers }).then(response => (this.data = response.data));
    }

}

export default new RegimeService();